import request from '@/utils/request.js';
// 黑喵游戏板块及游戏列表
export const getHmGameList = () => request({ url: '/v1/game/list', method: 'get' });
// 获取游戏搜索历史列表
export const getSearchHistoryList = () =>
  request({ url: '/platform/v1/app_search_logs/get_app_search_logs_list', method: 'get' });
// 删除游戏搜索历史列表
export const delSearchHistoryList = data =>
  request({ url: '/platform/v1/app_search_logs/del_app_search_logs', method: 'post', data });
// 获取游戏搜索结果列表
export const getSearchGameList = data =>
  request({ url: '/platform/v1/app_info/get_app_info_list', method: 'post', data });


// 热门游戏
export const getHotList = () => request({ url: '/v1/game/hot_list', method: 'get' });
// 热游排行榜
export const getRankList = () => request({ url: '/v1/game/rank_list', method: 'get' });
// 热游排行榜
export const getPlateList = () => request({ url: '/v1/game/plate_list', method: 'get' });
// 搜索列表
export const getSearchList = (keyword) => request({ url: '/v1/game/search_list', params: {keyword}, method: 'get' });
// - 埋点数据上报
export const reportDataApi = (data) => request({ url: '/v1/report/data', data, method: 'post' });